// frontend/src/routes/AdminProtectedRoute.jsx
//
// Admin-only route guard — completely separate from ProtectedRoute.jsx.
// Reads adminUser and adminLoading from AdminContext (not AuthContext).

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "../context/AdminContext";

const AdminProtectedRoute = ({ children }) => {
  const { adminUser, adminLoading } = useAdmin();
  const location = useLocation();

  if (adminLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "#0f172a",
          color: "#94a3b8",
          fontFamily: "'Inter', sans-serif",
          fontSize: "1rem",
          gap: "12px",
        }}
      >
        <span
          style={{
            width: 20,
            height: 20,
            border: "2px solid #6366f1",
            borderTopColor: "transparent",
            borderRadius: "50%",
            display: "inline-block",
            animation: "spin 0.8s linear infinite",
          }}
        />
        Verifying admin session...
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!adminUser) {
    // Preserve the intended destination so AdminLogin can redirect back after auth
    return (
      <Navigate
        to={`/admin/login?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    );
  }

  return children;
};

export default AdminProtectedRoute;
